import { EquipmentItemStatus } from '@navio/nsdk';
import { NoddiIcon } from 'noddi-ui-common';
import { NoddiBadge } from 'noddi-ui-web';
import { EQUIPMENT_ITEM_STATUS_LABEL_MAP } from 'noddi-util';
import { EQUIPMENT_ITEM_STATUS_ICON } from './EquipmentStatusIcon';

const VARIANT_BY_STATUS = {
  [EquipmentItemStatus.AVAILABLE]: 'success',
  [EquipmentItemStatus.IN_USE]: 'info',
  [EquipmentItemStatus.MAINTENANCE]: 'warning',
  [EquipmentItemStatus.LOST]: 'destructive'
} as const;

export const EquipmentItemStatusBadge = ({ status }: { status: EquipmentItemStatus }) => (
  <NoddiBadge variant={VARIANT_BY_STATUS[status]}>
    <NoddiIcon name={EQUIPMENT_ITEM_STATUS_ICON[status]} size='small' />
    {EQUIPMENT_ITEM_STATUS_LABEL_MAP[status]}
  </NoddiBadge>
);
